import { isWeb, useCheckoutPaymentVerificationMutation } from "@stepapp/core";
import { Block, Button, Image, Loader, spacing } from "@stepapp/ui";
import { useLocalSearchParams } from "expo-router";
import * as WebBrowser from "expo-web-browser";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { StyleSheet } from "react-native";

import { error, success } from "../../../src/assets/images";
import { ServiceSceneDescription, ServiceSceneHeader } from "../../../src/components";
import { APP_URL } from "../../../src/config/urls";

const AuthenticationCompleteScreen = () => {
  const { t } = useTranslation();
  const { checkoutId = "" } = useLocalSearchParams<{ checkoutId?: string }>();
  const [isSuccess, setIsSuccess] = useState(false);

  const [paymentVerification, { loading }] = useCheckoutPaymentVerificationMutation();

  // biome-ignore lint/correctness/useExhaustiveDependencies: skip
  useEffect(() => {
    const verifyPayment = async () => {
      const { data } = await paymentVerification({
        variables: { input: { checkoutId, returnUrl: APP_URL } },
      });

      const isConfirmed = !!data?.checkoutPaymentVerification.confirmed;

      if (isConfirmed) {
        if (isWeb) {
          setTimeout(() => {
            window?.opener?.postMessage("3DS-authentication-complete");
          }, 1000);
        }
        setIsSuccess(true);
      }

      setTimeout(() => {
        handleClosePage();
      }, 10000);
    };

    verifyPayment();
  }, []);

  const handleClosePage = useCallback(() => {
    if (isWeb) {
      window.close();
      return;
    }
    WebBrowser.dismissBrowser();
  }, []);

  if (loading) {
    return (
      <Block alignCenter justifyCenter height={30}>
        <Loader />
      </Block>
    );
  }

  return (
    <>
      <Block alignCenter>
        <Image
          height={spacing.unit * 9}
          source={isSuccess ? success : error}
          width={spacing.unit * 9}
        />

        <ServiceSceneHeader
          name={
            isSuccess
              ? t("verification.paymentVerificationConfirmed")
              : t("verification.paymentVerificationFailed")
          }
        />

        {!isSuccess && (
          <ServiceSceneDescription
            marginBottom={0}
            description={t("verification.retryVerification")}
          />
        )}
        <ServiceSceneDescription description={t("verification.closePage")} />
      </Block>
      <Button
        style={styles.closeButton}
        onPress={() => handleClosePage()}
        type="primary"
        label={t("common.closePage")}
      />
    </>
  );
};

export default AuthenticationCompleteScreen;

const styles = StyleSheet.create({
  closeButton: {
    marginTop: spacing.unit * 5,
  },
});
